import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const $ = jQuery;

export default class Swipers {
    constructor(options = null) {}

    init() {
        this.__swiper1(); // area includes
    }

    __swiper1() {
        const swiper = new Swiper(".js-area-includes-swiper", {
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            speed: 200,
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: true,
            loop: true,
            keyboard: {
                enabled: true,
            },
            // allowTouchMove: false,
            // simulateTouch: false,
            allowTouchMove: true,
            simulateTouch: true,
            // navigation: {
            //     prevEl: ".js-area-includes-prev",
            //     nextEl: ".js-area-includes-next",
            // },
        });
    }
}
